import { v4 as uuid } from "uuid";

const LOCAL_HOSTNAME = "localhost.tomtom.com";
const DEV_HOSTNAME = "dev.plan.tomtom.com";
const BETA_PREVIEW_HOSTNAME = "beta.preview.plan.tomtom.com";

const DEV_SSO_URL = "https://webproxy.solaris.test.tomtom.com/samlsso";
const PROD_SSO_URL = "https://www.tomtom.com/samlsso";

export const getServiceProviderName = (hostname: string) =>
    hostname === LOCAL_HOSTNAME || hostname.includes(DEV_HOSTNAME) ? DEV_HOSTNAME : hostname;

export const getSamlSSOUrl = (hostname: string) => {
    if (hostname === LOCAL_HOSTNAME || hostname.includes(DEV_HOSTNAME) || hostname === BETA_PREVIEW_HOSTNAME) {
        return DEV_SSO_URL;
    }
    return PROD_SSO_URL;
};

export const getLoginUrl = (hostname: string) =>
    `${getSamlSSOUrl(hostname)}?service=onetomtom&spEntityID=${getServiceProviderName(hostname)}`;

export const getLogoutUrl = (hostname: string) => {
    const port = hostname === LOCAL_HOSTNAME || hostname.includes(DEV_HOSTNAME) ? ":9000" : "";
    const returnToHostname = hostname.includes(DEV_HOSTNAME) ? LOCAL_HOSTNAME : hostname;
    const returnToUrl = encodeURIComponent(`https://${returnToHostname}${port}`);

    return `${getSamlSSOUrl(hostname)}?slo=true&spEntityID=${getServiceProviderName(
        hostname
    )}&returnTo=${returnToUrl}&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST`;
};

export const samlLogoutRedirect = (hostname: string, logoutId: string) => {
    const samlSSOUrl = getSamlSSOUrl(hostname);
    const date = new Date();

    const samlXmlPayload = `<?xml version="1.0" encoding="UTF-8"?>
                <saml2p:LogoutResponse xmlns:saml2p="urn:oasis:names:tc:SAML:2.0:protocol"
                    ID="${uuid().replace(/-/g, "")}" Version="2.0" IssueInstant="${date.toISOString()}"
                    Destination="${samlSSOUrl}" InResponseTo="${logoutId}">
                    <saml2:Issuer xmlns:saml2="urn:oasis:names:tc:SAML:2.0:assertion">${getServiceProviderName(
                        hostname
                    )}</saml2:Issuer>
                    <saml2p:Status>
                        <saml2p:StatusCode Value="urn:oasis:names:tc:SAML:2.0:status:Success" />
                    </saml2p:Status>
                </saml2p:LogoutResponse>`;
    const samlBase64Payload = window.btoa(samlXmlPayload);

    // Form needed for SAML logout full page redirect. fetch() won't trigger a full page redirect!
    const form = document.createElement("form");
    form.method = "POST";
    form.action = samlSSOUrl;

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "SAMLResponse";
    input.value = samlBase64Payload;
    form.appendChild(input);

    document.body.appendChild(form);
    form.submit();
};
